import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import EventBusyIcon from '@mui/icons-material/EventBusy';

const BoxEmpty = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
    padding: "2rem",
});

const BoxEmptyCard = styled(Box)({
    textAlign: "center",
    padding: "3rem 2rem",
    borderRadius: "16px",
    background: "linear-gradient(145deg, #f9fafc, #eef2f7)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
});

const TextEmpty = styled(Typography)({
    fontSize: "1.6rem",
    fontWeight: 600,
    color: "#555",
    marginTop: "1rem",
});

const NoneEventComponent = () => {
  return (
    <BoxEmpty>
      <BoxEmptyCard>
          <EventBusyIcon sx={{ fontSize: 70, color: "#bbb" }} />
          <TextEmpty>
              現在、開催期間中のイベントはございません。
          </TextEmpty>
          <Typography sx={{ fontSize: "0.95rem", color: "#888", marginTop: "0.5rem" }}>
              新しいイベントの開始をお待ちください。
          </Typography>
      </BoxEmptyCard>
    </BoxEmpty>
  )
}

export default NoneEventComponent
